import { Component } from '@angular/core';

@Component({
  selector: 'app-test-device',
  templateUrl: './test-device.component.html',
  styleUrls: ['./test-device.component.scss']
})
export class TestDeviceComponent {

}
